export default __webpack_public_path__ + "static/media/logo-mark.2a013052.png";